import { SearchCompanyDto } from "@api/client";
import { companyAddCompany, companySearchCompany } from "common/_redux/company/actions";
import { praticaIdPraticaSelector } from "common/_redux/pratica/selectors";
import { clearSubjects } from "common/_redux/subject/actions";
import BftButton from "common/components/button";
import BftInput from "common/components/input";
import MessageModal from "common/components/message-modal";
import { STATI_ATTIVITA, StatoAttivitaEnum } from "constants/global";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { FormEvent, useState } from "react";
import { Card, OverlayTrigger, Pagination, Row, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const title = "Cerca la tua impresa";
const subtitle =
	"Se sei una ditta individuale o un professionista digita prima la tua P.IVA o in mancanza, il tuo Codice Fiscale. Se non ricordi alcuno di questi valori, inserisci l'anagrafica della tua attività commerciale";

const CercaImpresa: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const idPratica = useAppSelector(praticaIdPraticaSelector);

	const [companySearchValue, setCompanySearchValue] = useState("");
	const [searchResponse, setSearchResponse] = useState<SearchCompanyDto>();
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchByCap, setSearchByCap] = useState<boolean>(false);
	const [cap, setCap] = useState<string>("");
	const [filteredCompanies, setFilteredCompanies] = useState<SearchCompanyDto>();
	const [showModal, setShowModal] = useState(false);

	const handleCloseModal = () => setShowModal(false);
	const handleShowModal = () => setShowModal(true);

	const MESSAGE_MODAL = `Gentile cliente, la società non risulta attiva,
	 per questo motivo siamo impossibilitati nel dare seguito alla procedura di on-boarding.
	 Potrà continuare solo quando lo stato sarà Attivo. Nel caso
  desideri maggiori chiarimenti non esiti a contattare il servizio clienti
  al Numero Verde 800.693.173 indicando il seguente codice pratica N. ${idPratica}.`;

	const companiesPerPage = 5;
	const companyList =
		cap && cap.length > 0 ? filteredCompanies?.companies : searchResponse?.companies;
	const totalCompanies = companyList?.length || 0;
	const totalPages = Math.ceil(totalCompanies / companiesPerPage);

	const indexOfLastCompany = currentPage * companiesPerPage;
	const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
	const currentCompanies = companyList?.slice(indexOfFirstCompany, indexOfLastCompany);

	const goBack = () => {
		navigate(-1);
	};

	const handleCompanyValueChange = (e: any) => {
		setCompanySearchValue(e.target.value);
	};

	const handleSearchCompany = (e: FormEvent) => {
		e.preventDefault();

		dispatch(companySearchCompany(companySearchValue))
			.unwrap()
			.then((res) => {
				if (res) {
					setSearchResponse(res);
					setCurrentPage(1);
				}
			});
	};

	const handlePageClick = (pageNumber: number) => {
		setCurrentPage(pageNumber);
	};

	const handleChangeCap = (e: any) => {
		setCap(e.target.value);

		const filteredCompanies = searchResponse?.companies?.filter(
			(el: any) => el.indirizzo.cap && el.indirizzo.cap.includes(e.target.value)
		);

		setFilteredCompanies({ ...searchResponse, companies: filteredCompanies });

		setCurrentPage(1);
	};

	const handleSelectCompany = async (idCompany: string) => {
		if (
			searchResponse &&
			searchResponse.companies &&
			searchResponse.companies.length > 0 &&
			idCompany !== "0"
		) {
			const company = searchResponse.companies.find((el) => el.idSoggetto === idCompany);

			if (!isCompanyActive(company)) {
				handleShowModal();
				return;
			}
		}

		dispatch(companyAddCompany(idCompany))
			.unwrap()
			.then((res) => {
				if (res) {
					sessionStorage.removeItem("subjectDetail");
					dispatch(clearSubjects());
					navigate(AppRouterService.get(PathEnum.step2));
				}
			});
	};

	const isCompanyActive = (company: any) => {
		return company.codiceStatoAttivita === "A" || company.codiceStatoAttivita === undefined;
	};

	const getCompanyStatus = (stato: StatoAttivitaEnum) => {
		return `Stato: ${STATI_ATTIVITA[stato] || "Non disponibile"}`;
	};

	return (
		<>
			<Card className="shadow">
				<Card.Body>
					<h4 className="ms-3 mt-3 mb-4">{title}</h4>
					<div className="mx-3 mb-3">
						<span className="gray m-0">{subtitle}</span>
					</div>

					<form onSubmit={handleSearchCompany}>
						<Row className="mb-3">
							<div className="col-sm-12 col-xl-8">
								<BftInput
									type={"text"}
									name={"company"}
									placeholder={"Partita IVA o numero REA o nome Azienda*"}
									value={companySearchValue}
									onChange={(e) => handleCompanyValueChange(e)}
									autoFocus
								/>
							</div>

							<div className="col-sm-12 col-xl-3">
								<BftButton
									type="submit"
									className="btn-buffetti w-100"
									style={{ height: "calc(3.5rem + 2px)", minWidth: "7rem" }}
									isDisabled={companySearchValue.trim().length < 3}
								>
									Cerca
								</BftButton>
							</div>
						</Row>
					</form>

					{searchResponse?.companies?.length === 0 && (
						<div
							className="d-flex justify-content-between align-items-center gray-container"
							style={{ minHeight: "6rem" }}
						>
							<div>
								<h5 className="container">Non trovi la tua impresa?</h5>
								<span className="gray">Aggiungila manualmente.</span>
							</div>

							<BftButton
								className="btn-buffetti-secondary"
								onClick={() => handleSelectCompany("0")}
								style={{
									minHeight: "2rem",
									width: "2rem",
									fontSize: "1rem",
									padding: "0",
									borderRadius: "0.375rem",
									marginRight: "1rem",
								}}
							>
								+
							</BftButton>
						</div>
					)}
				</Card.Body>
			</Card>

			{searchResponse && (
				<>
					<div className="d-flex justify-content-between flex-wrap container">
						{searchResponse.companiesTotalNumber == 1 ? (
							<div className="d-flex my-3">
								<span className="small font-weigth-bold">
									{searchResponse.companiesTotalNumber}
								</span>
								<span className="gray small m-0">risultato trovato</span>
							</div>
						) : (
							<div className="d-flex my-3">
								<span className="small font-weigth-bold">
									{searchResponse.companiesTotalNumber}
								</span>
								<span className="gray small m-0">risultati trovati</span>
							</div>
						)}

						{totalPages > 1 && (
							<Pagination className="mt-3">
								{[...Array(totalPages)].map((_, i) => (
									<li key={i} className={`page-item${currentPage === i + 1 ? " active" : ""}`}>
										<button className="page-link" onClick={() => handlePageClick(i + 1)}>
											{i + 1}
										</button>
									</li>
								))}
							</Pagination>
						)}
					</div>

					<div className="ms-1">
						<span
							className="gray fw-bold"
							style={{ cursor: "pointer" }}
							onClick={() => setSearchByCap(!searchByCap)}
						>
							Aiutati inserendo il CAP della tua sede legale.
							{searchByCap ? (
								<i className="ms-2 fa-solid fa-caret-up fa-lg"></i>
							) : (
								<i className="ms-2 fa-solid fa-caret-down fa-lg"></i>
							)}
						</span>

						{searchByCap && (
							<BftInput
								className="col-12 col-sm-6 col-lg-4 my-3"
								type={"text"}
								name={"cap"}
								placeholder={"Inserisci il CAP"}
								value={cap}
								icon="fa-magnifying-glass"
								inputStyle={{ borderLeftStyle: "none" }}
								containerStyle={{ minWidth: "14rem" }}
								onChange={(e) => handleChangeCap(e)}
								inputClass="shadow-none"
							/>
						)}

						{companyList?.length === 0 && (
							<div className="mb-3">
								<span className="gray">Nessun risultato trovato con il CAP inserito.</span>
							</div>
						)}
					</div>

					{currentCompanies?.map((item: any) => (
						<div key={item.idSoggetto}>
							<Card
								className="shadow clickable"
								onClick={() => handleSelectCompany(item.idSoggetto)}
							>
								<Card.Body>
									<div className="d-flex align-items-center">
										<div>
											<OverlayTrigger
												key={`status-${item.idSoggetto}`}
												overlay={
													<Tooltip id={`tooltip-${item.idSoggetto}`}>
														{getCompanyStatus(item.codiceStatoAttivita)}
													</Tooltip>
												}
											>
												<div
													className={`square-icon-shadow icon-card-v2${
														!isCompanyActive(item) ? "-red" : ""
													}`}
												>
													<div className="square-icon-container">
														<i className={`fas fa-shop square-icon`}></i>
													</div>
												</div>
											</OverlayTrigger>
										</div>
										<div className="col-lg-10">
											<h6 className="m-0 ms-3">
												{item.codiceREA}
												{item.codiceREA && " - "}
												{item.denominazione}
											</h6>
											<span className="gray">
												{item.indirizzo.descrizione}
												{item.indirizzo.descrizione && item.indirizzo.comune && " - "}
												{item.indirizzo.comune}
												{item.indirizzo.comune && item.indirizzo.cap && ", "}
												{item.indirizzo.cap}
												{item.indirizzo.cap && item.indirizzo.provincia && ", "}
												{item.indirizzo.provincia}
											</span>
											{item.partitaIva && (
												<div>
													<span className="gray">P.IVA {item.partitaIva}</span>
												</div>
											)}
										</div>
										<div className="col-lg-1 text-center">
											<i className="fa-solid fa-chevron-right"></i>
										</div>
									</div>
								</Card.Body>
							</Card>
						</div>
					))}
				</>
			)}

			<div className="col-1 mx-3">
				<BftButton className="btn-buffetti-secondary px-3" onClick={goBack}>
					<i className="fas fa-arrow-left me"></i>
				</BftButton>
			</div>

			<MessageModal show={showModal} onClose={handleCloseModal} message={MESSAGE_MODAL} />
		</>
	);
};

export default CercaImpresa;
